import { ComponentProps, Fragment, ReactElement, ReactNode } from "react"
import { proxy, ref, useSnapshot } from "valtio"

let hideTimeout: NodeJS.Timeout | null = null
let showTimeout: NodeJS.Timeout | null = null
const store = proxy({
  activeItem: "",
  activeItemContent: ref<ReactElement>(<Fragment />),
  activeSince: 0,
  wasKeyboardActivated: false,
  showMenu: (id: string, contents: ReactElement, wasKeyboardActivated = false, delay = 0) => {
    clearTimeout(hideTimeout!)
    clearTimeout(showTimeout!)
    showTimeout = setTimeout(() => {
      store.activeItemContent = ref(contents)
      store.activeItem = id
      store.wasKeyboardActivated = wasKeyboardActivated
      store.activeSince = Date.now()
    }, delay)
  },
  hideMenu: () => {
    clearTimeout(hideTimeout!)
    clearTimeout(showTimeout!)
    // store.activeItemContent = null!
    store.activeItem = ""
    store.wasKeyboardActivated = false
  },
  hideSoon: () => {
    clearTimeout(hideTimeout!)
    clearTimeout(showTimeout!)
    hideTimeout = setTimeout(store.hideMenu, 200)
  },
  cancelHide: () => {
    clearTimeout(hideTimeout!)
    clearTimeout(showTimeout!)
  },
  adminRenderTarget: null as HTMLDivElement | null,
  setAdminRenderTarget: (el: HTMLDivElement | null) => {
    store.adminRenderTarget = el ? ref(el) : null
  },
})

export function useMegaMenu() {
  return useSnapshot(store)
}

export function useMegaMenuButtonProps(id: string, contents: ReactElement): ComponentProps<"button"> {
  const ctx = useMegaMenu()

  return {
    onClick: (e) => {
      ctx.showMenu(id, contents)
    },
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()
        ctx.showMenu(id, contents, true)
      }
    },
    onPointerEnter: (e) => {
      if (!env.admin && e.pointerType === "mouse") {
        ctx.showMenu(id, contents, false, ctx.activeItem ? 0 : 200)
      }
    },
    onPointerLeave: (e) => {
      if (!env.admin && e.pointerType === "mouse") {
        ctx.hideSoon()
      }
    },
  }
}
